import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedApiService } from './shared-api.service';
import { inject, Injectable } from '@angular/core';
import { DocumentTypeEnum } from 'common';
import { catchError, of } from 'rxjs';
import dayjs from 'dayjs';

@Injectable({
    providedIn: 'root'
})
export class ApplicationService {

    private apiService = inject(SharedApiService)
    private matSnackbar = inject(MatSnackBar);

    public async onRequestQuote<T extends { applicationDatum: any; }>(row: T): Promise<void> {
        return new Promise<void>((resolve, reject) => {

            const applicationId: number = row.applicationDatum.id;
            
            const reference: string = row.applicationDatum.reference;

            if (reference && applicationId) {
                this.apiService.vendorApplicationDocument(DocumentTypeEnum.Quotation, applicationId)
                    .pipe(catchError(error => {
                        console.error('Failed to request a quote.', error);
                        this.matSnackbar.open('Failed to download a quote.', 'Close', { duration: 3000 });
                        reject('Failed to download a quote.');
                        return of(null);
                    }))
                    .subscribe((base64) => {
                        if (base64) {
                            // Download the base64.
                            const link = document.createElement('a');
                            link.href = 'data:application/pdf;base64,' + base64;
                            link.download = `Quotation${reference ? ' ' + reference : ''} ${dayjs().format('DD-MMM-YYYY HH-mm')}.pdf`;
                            link.click();
                            resolve();
                        }
                    });

            } else {
                this.matSnackbar.open('Insufficient data to generate quote. Please complete the application and try again.', 'Close', { duration: 8000 });
                reject('Insufficient data to generate quote. Please complete the application and try again.');
            }
        });
    }


}